import apiEmailLog from '@/api/emailLog';

const defaultState = () => ({
	emailLogData: [],
	emailLogDetail: {},
	emailLogPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setEmailLog(state, data) {
		state.emailLogData = data.data
		state.emailLogPagination = data.pagination;
	},
	setEmailLogDetail(state, data) {
		state.emailLogDetail = data
	},
	saveEmail(state, data) {
		state.response = data
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataEmailLog(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getEmailLog({ commit, dispatch }, params) {
		apiEmailLog.getDataEmailLog(params).then(({ data: { data } }) => {
			commit('setEmailLog', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setEmailLog', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	getEmailLogEcommerce({ commit, dispatch }, params) {
		apiEmailLog.getDataEmailLogEcommerce(params).then(({ data: { data } }) => {
			commit('setEmailLog', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setEmailLog', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	setDetailEmailLog({ commit }, params) {
		commit('setEmailLogDetail', params);
	},
	success({ commit }, data) {
		commit("saveEmail", data);
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};